module.exports = __webpack_public_path__ + "img/side_zipper_length.335a5708.png";